import React, {Component} from 'react';
import Preloader from '../../../components/preloader';
import EmptyState from '../../../components/empty-state-container';

// "2026-07-03T23:25:48.000Z" → "Jul 3, 2026, 11:25 PM" (viewer's locale).
export function formatDateTime(raw) {
  if (!raw) return '';
  const d = new Date(raw);
  if (isNaN(d.getTime())) return String(raw);
  return d.toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
}

// stats is stored as JSON; depending on the column type it comes back as an
// object (JSON column) or a string (TEXT). Accept both.
export function parseStats(stats) {
  if (!stats) return null;
  if (typeof stats === 'string') {
    try {
      return JSON.parse(stats);
    } catch (e) {
      return null;
    }
  }
  return stats;
}

class SavedRunsList extends Component {
  render() {
    const {history, loading, onOpen} = this.props;
    const runs = history || [];

    return (
      <div className="sc-history-panel">
        <h3 className="sc-history-title">Saved comparisons</h3>

        {loading && <Preloader loading />}
        {!loading && runs.length === 0 && <EmptyState message="No saved comparisons yet" />}

        {!loading && runs.length > 0 && (
          <div className="sc-history-list" data-testid="sc-history-table">
            {runs.map((run) => {
              const id = run.comparisonId || run.comparison_id || run.id;
              const source = run.sourceSchema || run.source_schema || '—';
              const target = run.targetSchema || run.target_schema || '—';
              const stats = parseStats(run.stats);
              return (
                <div
                  key={id}
                  className="sc-history-card"
                  data-testid={`sc-history-row-${id}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => onOpen(id)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onOpen(id);
                    }
                  }}
                >
                  <div className="sc-history-card-top">
                    <span className="sc-history-date">
                      {formatDateTime(run.createdAt || run.created_at)}
                    </span>
                    {/*
                      A withheld `stats` parses to {redacted: true} (redaction.sentinelFor keeps the
                      JSON contract). Without the second test the three spans below would each fall
                      to `|| 0` and print "+0 −0 ~0" — fabricated counts, worse than the blank this
                      badge showed when the sentinel was unparseable and parseStats returned null.
                    */}
                    {stats && !stats.redacted && (
                      <span className="sc-history-stats">
                        <span className="sc-hist-added">+{stats.objectsAdded || 0}</span>
                        <span className="sc-hist-removed">−{stats.objectsRemoved || 0}</span>
                        <span className="sc-hist-modified">~{stats.objectsModified || 0}</span>
                      </span>
                    )}
                  </div>
                  <div className="sc-history-schemas">
                    <span className="sc-history-schema">{source}</span>
                    <span className="sc-history-arrow">→</span>
                    <span className="sc-history-schema">{target}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default SavedRunsList;
